import { api, ApiError } from './api';
import type {
  Event,
  ConflictWarning,
} from 'commoncal-shared';

export type CreateEventInput = {
  calendar_id: string;
  title: string;
  description?: string;
  address?: string;
  phone?: string;
  start_at: string;
  end_at: string;
  start_date?: string;
  end_date?: string;
  all_day?: boolean;
  rrule?: string;
  exdate?: string[];
  tags?: string[];
  as_kocal?: boolean;
};

export type AddEventOptions = {
  onConflict?: 'warn' | 'error';
};

export type AddEventResult = {
  event: Event;
  conflicts: ConflictWarning;
};

export class ConflictError extends Error {
  constructor(public readonly conflicts: ConflictWarning) {
    super('Event conflicts with existing events');
    this.name = 'ConflictError';
  }
}

export async function addEventToCalendar(
  input: CreateEventInput,
  options?: AddEventOptions
): Promise<AddEventResult> {
  const onConflict = options?.onConflict ?? 'warn';

  const result = await api.events.create(input);

  if (onConflict === 'error' && result.conflicts?.warned) {
    throw new ConflictError(result.conflicts);
  }

  return {
    event: result.event,
    conflicts: result.conflicts ?? null,
  };
}

export { ApiError };
